function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHours, getMinutes } from 'date-fns';
import TimeHeader from './header.js';
import Combobox from './combobox.js';
var __vue_script__ = {
  name: 'TimePickerPanel',
  components: {
    TimeHeader: TimeHeader,
    Combobox: Combobox
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-time-picker-panel'
    },
    value: {
      type: Date,
      required: true,
      default: function _default() {
        return new Date();
      }
    },
    format: String,
    showHour: Boolean,
    showMinute: Boolean,
    showSecond: Boolean,
    disabledHours: Function,
    disabledMinutes: Function,
    disabledSeconds: Function,
    hourStep: Number,
    minuteStep: Number,
    secondStep: Number,
    hideDisabledOptions: Boolean,
    use12Hours: Boolean
  },
  data: function data() {
    return {
      innerValue: null
    };
  },
  computed: {
    columns: function columns() {
      var showHour = this.showHour,
          showMinute = this.showMinute,
          showSecond = this.showSecond;
      return [showHour, showMinute, showSecond].filter(function (v) {
        return !!v;
      }).length;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          columns = this.columns;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-inner"), true), _defineProperty(_ref, "".concat(prefixCls, "-column-").concat(columns), true), _ref;
    },
    hourOptions: function hourOptions() {
      var disabledHours = this.disabledHours,
          hourStep = this.hourStep,
          hideDisabledOptions = this.hideDisabledOptions,
          genOptions = this.genOptions;
      var disabledOpts = disabledHours && disabledHours();
      return genOptions(24, disabledOpts, hideDisabledOptions, hourStep);
    },
    minuteOptions: function minuteOptions() {
      var innerValue = this.innerValue,
          disabledMinutes = this.disabledMinutes,
          minuteStep = this.minuteStep,
          hideDisabledOptions = this.hideDisabledOptions,
          genOptions = this.genOptions;
      var hour = getHours(innerValue);
      var disabledOpts = disabledMinutes && disabledMinutes(hour);
      return genOptions(60, disabledOpts, hideDisabledOptions, minuteStep);
    },
    secondOptions: function secondOptions() {
      var innerValue = this.innerValue,
          disabledSeconds = this.disabledSeconds,
          secondStep = this.secondStep,
          hideDisabledOptions = this.hideDisabledOptions,
          genOptions = this.genOptions;
      var hour = getHours(innerValue);
      var minute = getMinutes(innerValue);
      var disabledOpts = disabledSeconds && disabledSeconds(hour, minute);
      return genOptions(60, disabledOpts, hideDisabledOptions, secondStep);
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerValue = nVal;
      }
    }
  },
  created: function created() {
    this.innerValue = this.value;
  },
  methods: {
    genOptions: function genOptions(len, disabledOpts, hideDisabledOptions) {
      var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var options = [];

      for (var i = 0; i < len; i += step) {
        if (!disabledOpts || disabledOpts.indexOf(i) === -1 || !hideDisabledOptions) {
          options.push(i);
        }
      }

      return options;
    },
    onChange: function onChange(val) {
      this.innerValue = val;
      this.$emit('on-change', val);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_c('time-header', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.innerValue
    }
  }), _vm._v(" "), _c('combobox', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.innerValue,
      "format": _vm.format,
      "show-hour": _vm.showHour,
      "show-minute": _vm.showMinute,
      "show-second": _vm.showSecond,
      "hour-options": _vm.hourOptions,
      "minute-options": _vm.minuteOptions,
      "second-options": _vm.secondOptions,
      "disabled-hours": _vm.disabledHours,
      "disabled-minutes": _vm.disabledMinutes,
      "disabled-seconds": _vm.disabledSeconds,
      "use12-hours": _vm.use12Hours
    },
    on: {
      "on-change": _vm.onChange
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "panel.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);